import { FormState } from 'types/form';

export const setLocalStorage = (value: object | boolean, key: string): void => {
  const currentState = JSON.parse(localStorage.getItem('iLendingCDX') || '{}') as FormState;

  localStorage.setItem(
    'iLendingCDX',
    JSON.stringify({
      ...currentState,
      [key]: value,
    })
  );
};
